/**
 * ❓ お問合せ自動化 Hub
 * 仕様書: docs/01_spec/spec_inquiry_automation.md C-9
 */
import { HubTabs, type TabSpec } from '@/components/layout/HubTabs';

import { InquiryDataRetentionPage } from './InquiryDataRetentionPage';
import { InquiryQueuePage } from './InquiryQueuePage';
import { InquirySettingsPage } from './InquirySettingsPage';
import { QAManagementPage } from './QAManagementPage';

const TABS: TabSpec[] = [
  { tabKey: 'queue',          label: '承認キュー',   featureId: 'inquiry.queue',          render: () => <InquiryQueuePage /> },
  { tabKey: 'qa',             label: 'QA 管理',      featureId: 'inquiry.qa',             render: () => <QAManagementPage /> },
  { tabKey: 'settings',       label: '設定',         featureId: 'inquiry.settings',       render: () => <InquirySettingsPage /> },
  { tabKey: 'data-retention', label: 'データ保持',   featureId: 'inquiry.dataRetention', render: () => <InquiryDataRetentionPage /> },
];

export function InquiryHubPage() {
  return <HubTabs tabs={TABS} defaultTab="queue" />;
}
